import { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type FaqItem = {
  question: string;
  answer: string;
};
const FAQS: FaqItem[] = [{
  question: '¿Cómo recibiré el Sistema Maestro?',
  answer: 'Inmediatamente después del pago recibirás un correo con acceso a los 6 Manuales Maestros y los 5 Bonos Exclusivos en formato digital.'
}, {
  question: '¿Sirve si nunca he soldado?',
  answer: 'Sí. El sistema fue diseñado para ayudarte a evitar los errores que comete la mayoría de los principiantes y avanzar con un método claro desde el primer día.'
}, {
  question: '¿También funciona si ya tengo experiencia?',
  answer: 'Sí. Te ayudará a mejorar tus configuraciones, corregir errores y trabajar con mayor precisión y confianza.'
}, {
  question: '¿Necesito internet para usarlo?',
  answer: 'Solo para descargar el material. Después podrás consultarlo desde cualquier dispositivo, incluso imprimir las tablas para tenerlas siempre en tu taller.'
}, {
  question: '¿Es un pago único?',
  answer: 'Sí. Pagas una sola vez y el Sistema Maestro será tuyo para siempre: sin mensualidades ni renovaciones.'
}, {
  question: '¿Qué pasa si no me gusta?',
  answer: 'Simplemente escríbenos dentro de los primeros 7 días y te devolveremos el 100% de tu dinero. Así de sencillo.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="overflow-hidden rounded-2xl border border-white/10 bg-[#16161a]" data-id="element-183" data-mp="1jk6q4clan6bf">
      {FAQS.map((faq, index) => {
      const isOpen = openIndex === index;
      return <div key={faq.question} className="border-b border-white/10 last:border-b-0" data-id="element-184" data-mp="1xhlldxy8a8bb" data-mpi={index}>
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-amber-400" data-id="element-185" data-mp="1sis6c13am991">
              <span className="font-cond text-base font-semibold text-white" data-id="element-186" data-mp="237eii1xv3ygf">{faq.question}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 text-amber-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-187" data-mp="28714p0vo4p1d" />
            </button>
            {isOpen && <div className="px-5 pb-5 text-sm leading-relaxed text-neutral-300" data-id="element-188" data-mp="2h64q4bib5gj1">{faq.answer}</div>}
          </div>;
    })}
    </div>;
}